import { Grow, Tabs, Tab, Box } from '@mui/material'
import useImportingJobs from '../useJobs/useImportingJobs'
import useProcessingJobs from '../useJobs/useProcessingJobs'
import useExportingJobs from '../useJobs/useExportingJobs'
import settings from 'settings'
import { useExportJobs } from 'features/jobs/models/exportsModel'
import { JobsPopperTab } from 'features/jobs/types'
import useUserPermissions from 'features/account/state/useUserPermissions'

interface JobsTabsHeaderProps {
  selectedTab: JobsPopperTab
  onTabChange: (newTab: JobsPopperTab) => void
}

function JobsTabsHeader({ selectedTab, onTabChange }: JobsTabsHeaderProps) {
  const { exportViewportDataAvailable } = useUserPermissions()

  const { processingJobsNotCleared } = useProcessingJobs()
  const { exportingJobsNotCleared } = useExportingJobs()
  const exportJobs = useExportJobs()
  const { importingJobsNotCleared } = useImportingJobs()

  const showExportsTab = settings.enableExports || exportViewportDataAvailable
  const exportsDisabled = exportingJobsNotCleared.length + exportJobs.length === 0
  return (
    <>
      <Box>
        <Grow in={true}>
          <Tabs
            centered={true}
            value={selectedTab}
            onChange={(e, tab) => onTabChange(tab)}
            sx={{ minWidth: (theme) => theme.spacing(40) }}
            variant="fullWidth"
          >
            <Tab value={JobsPopperTab.Processing} disabled={!processingJobsNotCleared.length} label="Processing" />
            <Tab value={JobsPopperTab.Imports} disabled={!importingJobsNotCleared.length} label="Imports" />
            {showExportsTab && <Tab value={JobsPopperTab.Exports} disabled={exportsDisabled} label="Exports" />}
          </Tabs>
        </Grow>
      </Box>
    </>
  )
}

export default JobsTabsHeader
